import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";

import { Edit } from 'components/detail';
import { SimpleForm } from 'components/form';
import { Dialog, FlatButton } from "material-ui";

import { TextInput } from 'components/input';

import {
  DisabledInputOptions,
} from 'util/constants';
import {
  BULK_DELETE_MENU_TYPE_ALL,
  BULK_DELETE_MENU_TYPE_NOT_SYNC_FOODY
} from './utils';
import { crudGetList, setSaving } from "actions";
import { NowOchaShopResourceName } from "routes/advancedFunction/utils";
import { nowOchaShopsBackendPath } from "routes/advancedFunction/urls";


class ShopMenuDelete extends Component {
  state = {
    isOpenConfirm: false,
  };

  componentDidMount() {
    const shop_id = (this.props.data || {}).shop_id;
    if (shop_id) {
      this.props.dispatch(
        crudGetList(NowOchaShopResourceName, nowOchaShopsBackendPath, {shop_id})
      );
    }
  }

  openConfirmDialog = () => {
    this.setState({
      isOpenConfirm: true,
    })
  };

  handleCloseConfirmDialog = () => {
    this.props.dispatch(setSaving(false));
    this.setState({
      isOpenConfirm: false
    })
  };

  handleClickOnSubmitBtn = (props, basePath) => (record) => {
    if (!this.props.restaurant_id) {
      const requestData = {
        ...record,
        type: BULK_DELETE_MENU_TYPE_ALL,
      };
      props.crudUpdate(props.resource, props.id, requestData,
        props.data, props.editBackendPath, basePath);
    } else {
      this.setState({
        editFormProps: props,
        editFormRecord: record,
        basePath,
        isOpenConfirm: true,
      })
    }
  };

  submit = (type) => {
    const {editFormProps, editFormRecord, basePath} = this.state;

    const requestData = {
      ...editFormRecord,
      type,
    };

    editFormProps.crudUpdate(editFormProps.resource, editFormProps.id, requestData,
      editFormProps.data, editFormProps.editBackendPath, basePath);
  };

  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        keyboardFocused={true}
        onTouchTap={this.handleCloseConfirmDialog}
      />,
      <FlatButton
        label="Delete all (Ocha & Now)"
        primary={true}
        onTouchTap={() => this.submit(BULK_DELETE_MENU_TYPE_ALL)}
      />,
      <FlatButton
        label="Delete only for Ocha"
        primary={true}
        onTouchTap={() => this.submit(BULK_DELETE_MENU_TYPE_NOT_SYNC_FOODY)}
      />,
    ];

    return (
      <div>
        <Edit
          {...this.props}
          handleSubmit={this.handleClickOnSubmitBtn}
        >
          <SimpleForm>
            <TextInput options={DisabledInputOptions} source="shop_id" label="Shop ID"/>
            <TextInput options={DisabledInputOptions} source="shop_name" label="Shop Name"/>
          </SimpleForm>
        </Edit>
        <Dialog
          title="This shop is linking with Now, are you sure you want to delete menu items of the shops?"
          actions={actions}
          modal={false}
          open={this.state.isOpenConfirm}
        >
          Are you sure you want to do this action?
        </Dialog>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  const dataInNowOchaShop = state.admin[NowOchaShopResourceName].data;
  const keysInData = Object.keys(dataInNowOchaShop);
  return {
    data: state.admin[props.resource].data[decodeURIComponent(props.match.params.id)],
    restaurant_id: keysInData.length > 0 ? dataInNowOchaShop[keysInData[0]].restaurant_id : null,
  };
}

export default connect(mapStateToProps)(ShopMenuDelete);



// WEBPACK FOOTER //
// ./src/routes/shop/ShopMenuDelete.js